import Vue from 'vue'
import Vuex from 'vuex'
import pathify from './config/pathify'
import createCache from 'vuex-cache'
import apiHealth from './modules/apiHealth'
import axios from 'axios/index'
import address from './modules/address'
import camunda from './modules/camunda/index'
import cities from './modules/cities'
import comments from './modules/comments'
import communities from './modules/communities'
import companies from './modules/companies'
import config from './modules/config'
import Constants from 'src/utilities/constants'
import departments from './modules/departments'
import files from './modules/files/index'
import flexmonster from './modules/flexmonster'
import history from './modules/history'
import idaArchive from './modules/idaArchive'
import inspectorApp from './modules/inspectorApp/index'
import inspectorRouting from './modules/inspectorRouting'
import inTouchGps from './modules/inTouchGps'
import invoices from './modules/invoices/index'
import jobs from './modules/jobs/index'
import jobTemplates from './modules/jobTemplates'
import legalSubdivisions from './modules/legalSubdivisions'
import logs from './modules/logs'
import metadata from './modules/metadata'
import modalTracker from './modules/modalTracker'
import planNames from './modules/planNames'
import priceRules from './modules/priceRules'
import priorities from './modules/priorities'
import projects from './modules/projects/index'
import reportingView from './modules/reportingView'
import security from './modules/security'
import statuses from './modules/statuses'
import streets from './modules/streets'
import supplyPro from './modules/supplyPro/index'
import tasks from './modules/tasks/index'
import types from './modules/types'
import ui from './modules/ui'
import users from './modules/users/index'
import queues from './modules/queues'
import quickbooks from './modules/quickbooks'
import serviceAreas from './modules/serviceAreas'
import wizard from './modules/wizard'
import {axiosError, disableCache} from 'src/utilities/utils'
import {
  ptracGetEntity,
  ptracDeleteEntity,
  ptracPatchEntity,
  ptracPostEntities,
  ptracPost,
  ptracPut
} from 'src/utilities/ptracApi'
import {addHeaders} from 'src/utilities/authHeader'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    processing: false,
    countries: [
      {value: 'US', label: 'United States'},
      {value: 'CA', label: 'Canada'}
    ],
    states: [
      {value: 'AL', label: 'Alabama'},
      {value: 'AZ', label: 'Arizona'},
      {value: 'AR', label: 'Arkansas'},
      {value: 'CA', label: 'California'},
      {value: 'CO', label: 'Colorado'},
      {value: 'CT', label: 'Connecticut'},
      {value: 'DE', label: 'Delaware'},
      {value: 'DC', label: 'District of Columbia'},
      {value: 'FL', label: 'Florida'},
      {value: 'GA', label: 'Georgia'},
      {value: 'ID', label: 'Idaho'},
      {value: 'IL', label: 'Illinois'},
      {value: 'IN', label: 'Indiana'},
      {value: 'IA', label: 'Iowa'},
      {value: 'KS', label: 'Kansas'},
      {value: 'KY', label: 'Kentucky'},
      {value: 'LA', label: 'Louisiana'},
      {value: 'ME', label: 'Maine'},
      {value: 'MD', label: 'Maryland'},
      {value: 'MA', label: 'Massachusetts'},
      {value: 'MI', label: 'Michigan'},
      {value: 'MN', label: 'Minnesota'},
      {value: 'MS', label: 'Mississippi'},
      {value: 'MO', label: 'Missouri'},
      {value: 'MT', label: 'Montana'},
      {value: 'NE', label: 'Nebraska'},
      {value: 'NV', label: 'Nevada'},
      {value: 'NH', label: 'New Hampshire'},
      {value: 'NJ', label: 'New Jersey'},
      {value: 'NM', label: 'New Mexico'},
      {value: 'NY', label: 'New York'},
      {value: 'NC', label: 'North Carolina'},
      {value: 'ND', label: 'North Dakota'},
      {value: 'OH', label: 'Ohio'},
      {value: 'OK', label: 'Oklahoma'},
      {value: 'OR', label: 'Oregon'},
      {value: 'PA', label: 'Pennsylvania'},
      {value: 'RI', label: 'Rhode Island'},
      {value: 'SC', label: 'South Carolina'},
      {value: 'SD', label: 'South Dakota'},
      {value: 'TN', label: 'Tennessee'},
      {value: 'TX', label: 'Texas'},
      {value: 'UT', label: 'Utah'},
      {value: 'VT', label: 'Vermont'},
      {value: 'VA', label: 'Virginia'},
      {value: 'WA', label: 'Washington'},
      {value: 'WV', label: 'West Virginia'},
      {value: 'WI', label: 'Wisconsin'},
      {value: 'WY', label: 'Wyoming'}
    ],
  },
  actions: {
    async fetchById({}, payload) {
      return await ptracGetEntity(payload.endpoint + '/' + payload.id + disableCache())
    },
    async fetchByIds({}, payload) {
      let whichEntity = null
      if (payload.whichEntity) {
        whichEntity = payload.whichEntity
      }
      return await ptracPostEntities(`${payload.endpoint}/findByIdIn`, whichEntity, payload.ids)
    },
    async save({dispatch}, payload) {
      // bit of a hack to make the save method more flexible
      // put method below has been used with an id in two different places: payload.id & payload.data.id
      // tweaking this to accommodate
      if (payload.data.id && !payload.id) {
        payload.id = payload.data.id
      }
      if (payload.id) {
        return await dispatch('put', payload)
      }
      return await dispatch('post', payload)
    },
    async save2({dispatch}, payload) {
      if (payload.data.id && !payload.id) {
        payload.id = payload.data.id
      }
      if (payload.id) {
        return await dispatch('put2', payload)
      }
      return await dispatch('post2', payload)
    },
    async put({}, payload) {
      const nonreactivePayload = JSON.parse(JSON.stringify(payload))
      const url = process.env.VUE_APP_PTRAC_API_URI + '/' + nonreactivePayload.endpoint + '/' + nonreactivePayload.id
      try {
        if (nonreactivePayload.data.id) {
          delete nonreactivePayload.data.id // don't need to replace the existing id
          // remove read only properties
          delete nonreactivePayload._links
          delete nonreactivePayload.entityType
          delete nonreactivePayload.createdBy
          delete nonreactivePayload.createdAt
          delete nonreactivePayload.updatedBy
          delete nonreactivePayload.updatedAt
        }
        const response = await axios.put(url, nonreactivePayload.data, { headers: await addHeaders() })
        return {
          result: Constants.RETURN_CODES.SUCCESS,
          data: response.data
        }
      } catch (err) {
        return {
          result: Constants.RETURN_CODES.ERROR,
          errors: axiosError([], err)
        }
      }
    },
    async put2({}, payload) {
      const nonreactivePayload = JSON.parse(JSON.stringify(payload))
      if (nonreactivePayload.data.id) {
        delete nonreactivePayload.data.id // don't need to replace the existing id
        // remove read only properties
        delete nonreactivePayload._links
        delete nonreactivePayload.entityType
        delete nonreactivePayload.createdBy
        delete nonreactivePayload.createdAt
        delete nonreactivePayload.updatedBy
        delete nonreactivePayload.updatedAt
      }
      return await ptracPut(nonreactivePayload.endpoint + '/' + nonreactivePayload.id, nonreactivePayload.data)
    },
    async post({}, payload) {
      let url = process.env.VUE_APP_PTRAC_API_URI + '/' + payload.endpoint

      try {
        const response = await axios.post(url, payload.data, { headers: await addHeaders() })
        return {
          result: Constants.RETURN_CODES.SUCCESS,
          data: response.data
        }
      } catch (err) {
        return {
          result: Constants.RETURN_CODES.ERROR,
          errors: axiosError([], err)
        }
      }
    },
    async post2({}, payload) {
      return await ptracPost(payload.endpoint, payload.data, { headers: await addHeaders() })
    },
    async mergePatch({state}, payload) {
      const url = process.env.VUE_APP_PTRAC_API_URI + '/' + payload.endpoint + '/' + payload.id
      let result
      state.processing = true
      try {
        const response = await axios.patch(url, payload.data, { headers: await addHeaders(Constants.HEADERS.MERGE_PATCH.headers) })
        result = {
          result: Constants.RETURN_CODES.SUCCESS,
          data: response.data
        }
      } catch (err) {
        result = {
          result: Constants.RETURN_CODES.ERROR,
          errors: axiosError([], err)
        }
      }
      state.processing = false
      return result
    },
    async mergePatch2({state}, payload) {
      state.processing = true

      const url = `${payload.endpoint}/${payload.id}`
      const response = await ptracPatchEntity(url, payload.data, Constants.HEADERS.MERGE_PATCH.headers)

      state.processing = false

      return response
    },
    async patch({state}, payload) {
      const url = process.env.VUE_APP_PTRAC_API_URI + '/' + payload.endpoint + '/' + payload.id
      let result
      state.processing = true
      try {
        const response = await axios.patch(url, payload.data, { headers: await addHeaders(Constants.HEADERS.PATCH.headers) })
        result = {
          result: Constants.RETURN_CODES.SUCCESS,
          date: response.data
        }
      } catch (err) {
        result = {
          result: Constants.RETURN_CODES.ERROR,
          errors: axiosError([], err)
        }
      }
      state.processing = false
      return result
    },
    async delete({}, payload) {
      return ptracDeleteEntity(payload.endpoint + '/' + payload.id)
    }
  },
  getters: {
    states: (state) => {
      return state.states
    },
    countries: (state) => {
      return state.countries
    },
    idaInvoiceStatuses: (state) => {
      return state.idaInvoiceStatuses
    },
    idaInspectionResults: (state) => {
      return state.idaInspectionResults
    },
    processing: (state) => {
      return state.processing
    }
  },
  mutations: {
    processing(state, isProcessing) {
      state.processing = isProcessing
    }
  },
  modules: {
    address,
    apiHealth,
    camunda,
    comments,
    cities,
    communities,
    companies,
    config,
    departments,
    files,
    flexmonster,
    history,
    idaArchive,
    inspectorApp,
    inspectorRouting,
    inTouchGps,
    invoices,
    jobs,
    jobTemplates,
    legalSubdivisions,
    logs,
    metadata,
    modalTracker,
    planNames,
    priceRules,
    priorities,
    projects,
    queues,
    quickbooks,
    reportingView,
    security,
    serviceAreas,
    statuses,
    tasks,
    types,
    streets,
    supplyPro,
    ui,
    users,
    wizard
  },
  plugins: [
    pathify.plugin,
    createCache({ timeout: 24 * 60 * 60 * 1000 }) // one days
  ]
})
